import React from 'react'

const HomeBanner = () => {
  return (
    <>
      <section className="section-home overflow-hidden">
        <div className="our-agencies container">
          <div className="deco-block">
            <div className="row">
              <div className="col-sm-7 col-12">
                <div className="text-pro">
                  <div className="address">
                    <div className="title text-uppercase">
                      Professionnel ou particulier,
                     
                      profitez de notre service de
                     
                      création de devis en 1 clic et
                     
                      trouvez facilement tous les
                     
                      produits dont vous avez
                     
                      besoin
                    </div>
                    <div className="text">
                      Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed
                      diam nonummy
                      nibh euismod tincidunt ut laoreet dolore magna aliquam erat
                      volutpat. Ut wisi
                      enim ad minim veniam, quis nostrud exerci tation ullamcorper
                      suscipit lobortis
                      nisl ut aliquip ex ea commodo consequat. Duis autem vel eum
                      iriure dolor in
                      hendrerit in vulputate velit esse molestie consequat, vel illum
                      dolore
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-sm-5 col-12">
                <div className="outdoor">
                  {/* <img
                    src="/assets/images/Outdoor-wood-deck.png"
                    width="100%"
                    alt=""
                  /> */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}

export default HomeBanner